import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';

import { AuthService } from './auth.service';
import { AuthorizeService } from './authorize.service';

@Injectable()
export class AuthGuard  {
  constructor(
    private authService: AuthService,
    private authorizeService: AuthorizeService,
    private router: Router
  ) { }

  canActivate(
    _next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.authService.canActivateProtectedRoutes$
      .pipe(tap(ready => {
        if (ready) {
          // if (_next.data.expectedPermissions) {
            this.authorizeService
              .getUser()
              .pipe(
                first(),
                tap((user: any) => {
                  // eslint-disable-next-line no-bitwise
                  // if (
                  //   _next.data.expectedPermissions !== undefined &&
                  //   _next.data.expectedPermissions !==
                  //   (parseInt(user.permission, 10) & _next.data.expectedPermissions)
                  // ) {
                    this.router.navigate(['/not-authorized']);
                  // }
                }),
              )
              .subscribe();
          // }
        }
      }));
  }
}
